import { CreatorRolePermissionAssignment } from '@api'

import type {
  PermissionBlock,
  PermissionBlockModifiedPermissions,
} from './types'

export function transformToPermissionBlock(
  data: CreatorRolePermissionAssignment[],
  creators: { id: number; name: string }[],
): PermissionBlock[] {
  const permissionMap: Record<number, PermissionBlockModifiedPermissions> = {}
  const superCreatorPermissions: Partial<PermissionBlockModifiedPermissions> =
    {}

  data.forEach((item) => {
    if (item.assignToAllCreators && item.permission) {
      superCreatorPermissions[item.permission] = true
    } else if (item.creatorId && item.permission) {
      if (!permissionMap[item.creatorId]) {
        permissionMap[item.creatorId] = {} as PermissionBlockModifiedPermissions
      }
      permissionMap[item.creatorId][item.permission] = true
    }
  })

  const permissionBlocks: PermissionBlock[] = creators.map((creator) => ({
    creatorId: creator.id,
    creatorName: creator.name,
    permissions: permissionMap[creator.id] || {},
  }))

  permissionBlocks.unshift({
    creatorId: 0,
    creatorName: 'All Creators',
    type: 'SUPER_CREATOR',
    permissions: superCreatorPermissions,
  })

  return permissionBlocks
}
